
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { StatsDialogProps } from "./types";

export const StatsDialog = ({ isOpen, onClose, title, data, type }: StatsDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-flux-black text-white border border-flux-cyan/20">
        <DialogHeader>
          <DialogTitle className="text-flux-cyan">{title}</DialogTitle>
        </DialogHeader>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-flux-cyan">Name</TableHead>
              <TableHead className="text-flux-cyan">
                {type === "startups" ? "Role" : "Size"}
              </TableHead>
              <TableHead className="text-flux-cyan">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="text-white">{item.name}</TableCell>
                <TableCell className="text-white">
                  {type === "startups" ? item.role : item.size}
                </TableCell>
                <TableCell className="text-white">
                  {new Date(item.created_at).toLocaleDateString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
